import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import { IIndexAttributeData } from "../model/IndexAttributeData";
import IndexAttributeDataMapper from "../service/IndexAttributeDataMapper";

export default class CreateIndexAttributeDataInteractor {
  private createListResource: CreateListResourceInteractor<IIndexAttributeData>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(indexAttributeDataList: IIndexAttributeData[]) {
    return this.createListResource.execute(
      `/index-type-attribute/data`,
      indexAttributeDataList,
      {},
      IndexAttributeDataMapper
    );
  }
}
